import { createORPCClient } from "@orpc/client"
import { RPCLink } from "@orpc/client/fetch"
import { SimpleCsrfProtectionLinkPlugin } from "@orpc/client/plugins"
import type { RouterClient } from "@orpc/server"
import { createRouterClient, type InferRouterOutputs } from "@orpc/server"
import { createTanstackQueryUtils } from "@orpc/tanstack-query"
import { createIsomorphicFn } from "@tanstack/solid-start"
import { getRequestHeaders } from "@tanstack/solid-start/server"
import { router } from "~/lib/orpc/router"

const getORPCClient = createIsomorphicFn()
  .server(() =>
    createRouterClient(router, {
      /**
       * Provide initial context if needed.
       *
       * Because this client instance is shared across all requests,
       * only include context that's safe to reuse globally.
       * For per-request context, use middleware context or pass a function as the initial context.
       */
      context: async () => ({
        reqHeaders: getRequestHeaders() // provide headers if initial context required
      })
    })
  )
  .client((): RouterClient<typeof router> => {
    const link = new RPCLink({
      url: `${window.location.origin}/api/rpc`,
      plugins: [new SimpleCsrfProtectionLinkPlugin()]
    })

    return createORPCClient(link)
  })

export const client: RouterClient<typeof router> = getORPCClient()

// Used by QueryClient
export const orpc = createTanstackQueryUtils(client)

export type rpcOutputs = InferRouterOutputs<typeof router>
